"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.BOTTLENECKS_DATETIME_FORMAT = void 0;
exports.BOTTLENECKS_DATETIME_FORMAT = 'MM/DD/YYYY h:mm A';
//# sourceMappingURL=constants.js.map